// extracted by mini-css-extract-plugin
export default {"root":"t2RD1e","itemClickWrapper":"PtSCAY","imageZoomBtn":"UVGuXF","sizer":"vfpft9","imageWrapper":"GTJcFP","imageBorder":"uF91OU","image":"DE9zOy","overlay":"mMJVFD"};